<template>
  <v-container>
    <v-row>
      <div class="md-card md-theme-default">
        <div class="md-card-content">
          <div>
            <div class="header_title">
              <v-row no-gutters class="ma-3 header_title">
                <v-col cols="8" md="2" class="pt-6">
                  Logins
                  <br />
                  <br />
                </v-col>
                <v-col cols="12" md="10">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="3"> </v-col>
                    <v-col cols="12" md="2" sm="1" class="text-right">
                      <div style="width: 120px; float: right">
                        <v-select
                          outlined
                          v-model="perPage"
                          label="Per Page"
                          :items="[50, 100, 500]"
                          @change="getLogins"
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div
              class="md-content md-table md-theme-default table_borders"
              table-header-color="orange"
              value
            >
              <div
                class="
                  md-content md-table-content md-scrollbar md-theme-default
                "
              >
                <table>
                  <thead class="md-card-header">
                    <tr>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Timestamp</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Venue</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">User</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Email</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div
                            class="md-table-head-label"
                            @click="sortColumn('country')"
                          >
                            Country
                            <v-icon class="ml-2" color="#fff" small>
                              mdi-sort{{
                                orderBy == "country"
                                  ? "-" +
                                    (orderDir == "ASC"
                                      ? "ascending"
                                      : "descending")
                                  : ""
                              }}
                            </v-icon>
                          </div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div
                            class="md-table-head-label"
                            @click="sortColumn('country_code')"
                          >
                            Country Code
                            <v-icon class="ml-2" color="#fff" small>
                              mdi-sort{{
                                orderBy == "country_code"
                                  ? "-" +
                                    (orderDir == "ASC"
                                      ? "ascending"
                                      : "descending")
                                  : ""
                              }}
                            </v-icon>
                          </div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div
                            class="md-table-head-label"
                            @click="sortColumn('region')"
                          >
                            Region
                            <v-icon class="ml-2" color="#fff" small>
                              mdi-sort{{
                                orderBy == "region"
                                  ? "-" +
                                    (orderDir == "ASC"
                                      ? "ascending"
                                      : "descending")
                                  : ""
                              }}
                            </v-icon>
                          </div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div
                            class="md-table-head-label"
                            @click="sortColumn('region_code')"
                          >
                            Region Code
                            <v-icon class="ml-2" color="#fff" small>
                              mdi-sort{{
                                orderBy == "region_code"
                                  ? "-" +
                                    (orderDir == "ASC"
                                      ? "ascending"
                                      : "descending")
                                  : ""
                              }}
                            </v-icon>
                          </div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div
                            class="md-table-head-label"
                            @click="sortColumn('city')"
                          >
                            City
                            <v-icon class="ml-2" color="#fff" small>
                              mdi-sort{{
                                orderBy == "city"
                                  ? "-" +
                                    (orderDir == "ASC"
                                      ? "ascending"
                                      : "descending")
                                  : ""
                              }}
                            </v-icon>
                          </div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Zip Code</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Latitude</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Longitude</div>
                        </div>
                      </th>

                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Ip Address</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Timezone</div>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="md-table-row"
                      v-for="data in logins"
                      :key="data.id"
                    >
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.created | timeStamp }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.venue_name || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.first_name + " " + data.last_name || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.email || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.country || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.country_code || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.region || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.region_code || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.city || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.zip_code || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.latitude || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.longitude || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.ip_address || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.timezone || "NA" }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="totalPages"
              :page="page"
              total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      logins: [],
      page: 1,
      totalPages: 1,
      perPage: 10,
      orderBy: "updated_at",
      orderDir: "DESC",
      searchParams: {},
    };
  },
  mounted() {
    this.getLogins();
  },
  computed: {},
  watch: {
    page() {
      this.getLogins();
    },
  },
  methods: {
    getLogins() {
      let url =
        "venues/users/user-logins?page=" +
        this.page +
        "&per_page=" +
        (this.perPage != null ? this.perPage : 10) +
        "&order_by=" +
        this.orderBy +
        "&sort_order=" +
        this.orderDir;
      this.$http
        .get(url)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.logins = response.data.data;
            this.totalPages = response.data.total_pages;
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    sortColumn(type) {
      if (type == this.orderBy) {
        this.orderDir = this.orderDir == "ASC" ? "DESC" : "ASC";
      } else {
        this.orderDir = "DESC";
      }
      this.orderBy = type;
      this.getLogins();
    },
  },
};
</script>
<style scoped>
.validation-message {
  color: red;
  font-size: 12px;
}
.md-card {
  margin: 0 0 25px 0;
}
.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
</style>
